import { ESectionTrackStatus } from '@constants';
import { DefaultTheme } from 'styled-components';

import { defaultTheme } from '@/styles';

export const getSectionTrackingStyles = (
  status?: ESectionTrackStatus
): {
  backgroundColor: string;
  color: string;
  iconColor: keyof DefaultTheme['colors'];
} => {
  switch (status) {
    case ESectionTrackStatus.SEEN:
      return {
        backgroundColor: defaultTheme.colors.blue1,
        color: defaultTheme.colors.blue6,
        iconColor: 'blue6'
      };
    case ESectionTrackStatus.SUMMARISED:
      return {
        backgroundColor: defaultTheme.colors.purple1,
        color: defaultTheme.colors.purple6,
        iconColor: 'purple6'
      };
    case ESectionTrackStatus.REVISED:
      return {
        backgroundColor: defaultTheme.colors.orange2,
        color: defaultTheme.colors.orange7,
        iconColor: 'orange7'
      };
    case ESectionTrackStatus.STUDIED:
      return {
        backgroundColor: defaultTheme.colors.black3,
        color: defaultTheme.colors.black7,
        iconColor: 'black7'
      };
    case ESectionTrackStatus.KNOWN:
      return {
        backgroundColor: defaultTheme.colors.green1,
        color: defaultTheme.colors.green7,
        iconColor: 'green7'
      };

    default:
      return {
        backgroundColor: defaultTheme.colors.black1,
        color: defaultTheme.colors.black6,
        iconColor: 'black6'
      };
  }
};
